import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthMessageService {
  private _errorMessage = new BehaviorSubject<string | null>(null);
  errorMessage$ = this._errorMessage.asObservable();

  setErrorMessage(message: string | null) {
    this._errorMessage.next(message);
  }

  clearErrorMessage() {
    this._errorMessage.next(null);
  }
}
